import {
  Control,
  Controller,
  FieldErrors,
  Input,
  Switch,
  TextEditor,
  Typography,
} from '@otp/ui';
import { ResourceForm } from '../types';
import { useTranslation } from 'react-i18next';
import { ResourceFolderField } from './folders';
import { TagsField } from 'src/components/common/form/fields';
import { TagEntityType } from 'src/graphql/generated/graphql';

type GeneralInfoFieldProps = {
  control: Control<ResourceForm>;
  errors: FieldErrors<ResourceForm>;
};

export const GeneralInfoField = ({
  control,
  errors,
}: GeneralInfoFieldProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mt-4 flex gap-4">
        <div className="mb-4 w-1/2">
          <Controller
            name="name"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Input
                label={t('common.name')}
                placeholder={t('common.name')}
                error={!!errors.name}
                required={true}
                {...field}
                defaultValue={field.value}
              />
            )}
          />
        </div>
        <div className="mb-4 w-1/2">
          <Controller
            name="tagIds"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <div>
                <Typography variant="subtitle1">{t('common.tags')}</Typography>
                <TagsField field={field} entityType={TagEntityType.Resource} />
              </div>
            )}
          />
        </div>
      </div>
      <div className="mb-4">
        <Controller
          name="description"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div>
              <Typography
                className="mb-2"
                variant="subtitle1"
                color={!!errors.description ? 'red' : ''}
              >
                {t('common.description')}
                <span className="text-red-500"> *</span>
              </Typography>
              <TextEditor {...field} defaultValue={field.value} />
            </div>
          )}
        />
      </div>
      <div className="mb-4">
        <Controller
          name="folderIds"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div>
              <Typography className="mb-2" variant="subtitle1">
                {t('common.folders')}
                <span className="text-red-500"> *</span>
              </Typography>
              <ResourceFolderField
                field={field}
                error={!!errors.folderIds}
                multiple
              />
            </div>
          )}
        />
      </div>
      <div className="mb-4">
        <Controller
          name="isDisabled"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <div className="flex">
              <Typography variant="subtitle1" className="mt-2.5">
                {t('common.active')}
              </Typography>
              <Switch
                checked={!field.value}
                onChange={(_event, checked) => {
                  field.onChange(!checked);
                }}
              />
            </div>
          )}
        />
      </div>
    </>
  );
};
